import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

let defaultRedirect = "/_tab_novel"
if (process.env.VUE_APP_APP_ID === "app_ns") {
  defaultRedirect = "/_tab_discovery"
}

// _tab_ 开头的会清除history
const routes = [
  {
    path: "/",
    name: "root",
    redirect: defaultRedirect,
  }, {
    path: '/_tab_discovery',
    name: 'router_discovery',
    redirect: '/_tab_discovery/recommend',
  }, {
    path: "/_tab_discovery/recommend",
    name: 'router_movie_feed_page',
    component: () => import(/* webpackChunkName: "data" */ '@/components/forum/movie/MovieFeedPage.vue'),
    meta: {
      keepAlive: true,
    }
  }, {
    path: "/moment_create",
    name: 'router_moment_create',
    component: () => import(/* webpackChunkName: "data" */ '@/components/forum/moment/MomentCreate.vue'),
  }, {
    path: "/movie/:id",
    name: 'router_movie_id',
    component: () => import(/* webpackChunkName: "data" */ '@/components/forum/movie/MovieDetail.vue'),
  }, {
    path: "/moment/:id",
    name: 'router_moment_id',
    component: () => import(/* webpackChunkName: "data" */ '@/components/forum/moment/MomentDetailPage.vue'),
  }, {
    path: "/video/:id",
    name: 'router_video_id',
    component: () => import(/* webpackChunkName: "data" */ '@/components/forum/video/VideoDetail.vue'),
  }, {
    path: "/novel/:id",
    name: 'router_novel_id',
    component: () => import(/* webpackChunkName: "data" */ '@/components/forum/novel/ArticleRecord.vue'),
  }, {
    path: "/comic/:id",
    name: 'router_comic_id',
    component: () => import(/* webpackChunkName: "data" */ '@/components/forum/comic/ComicArticleRecord.vue'),
  }, {
    path: "/_tab_comic",
    name: 'router_tab_comic',
    component: () => import(/* webpackChunkName: "data" */ '@/components/forum/comic/ComicFrontPage.vue'),
    meta: {
      keepAlive: true,
    }
  }, {
    path: "/category_comic",
    name: 'router_comic_home',
    component: () => import(/* webpackChunkName: "data" */ '@/components/forum/comic/Category.vue'),
    meta: {
      keepAlive: true,
    }
  }, {
    path: "/cashier",
    name: 'router_cashier',
    component: () => import(/* webpackChunkName: "data" */ '@/components/cashier/Cashier.vue'),
  }, {
    path: "/_tab_novel",
    name: "router_novel",
    component: () => import(/* webpackChunkName: "data" */ '@/components/forum/novel/NovelFeedPage.vue'),
    meta: {
      keepAlive: true,
    }
  }, {
    path: "/search",
    name: "router_search",
    component: () => import(/* webpackChunkName: "data" */ '@/components/ugc_item/SearchPage.vue'),
    meta: {
      keepAlive: true,
    }
  }, {
    path: '/user_album/:id',
    name: 'router_user_album_id',
    component: () => import(/* webpackChunkName: "data" */ '@/components/forum/video/UserAlbumPage.vue')
  }, {
    path: "/bookshelf",
    name: "router_bookshelf",
    component: () => import(/* webpackChunkName: "data" */ '@/components/ugc_item/BookShelfPage.vue'),
  }, {
    path: "/moment_mine",
    name: "router_moment_mine",
    component: () => import(/* webpackChunkName: "data" */ '@/components/forum/moment/MomentMinePage.vue'),
    meta: {
      keepAlive: true,
    }
  }, {
    path: "/favorite",
    name: "router_favorite",
    component: () => import(/* webpackChunkName: "data" */ '@/components/ugc_item/FavoritePage.vue'),
    meta: {
      keepAlive: true,
    }
  }, {
    path: "/login",
    name: "router_login",
    component: () => import(/* webpackChunkName: "data" */ '@/components/user/Login.vue'),
  }, {
    path: "/login_sso",
    name: "router_login_sso",
    component: () => import(/* webpackChunkName: "data" */ '@/components/user/LoginSso.vue'),
  }, {
    path: "/_tab_mine",
    name: "router_mine",
    component: () => import(/* webpackChunkName: "data" */ '@/components/user/Mine.vue'),
  }, {
    path: '/profile/:id',
    name: 'router_profile_id',
    component: () => import(/* webpackChunkName: "data" */ '@/components/user/Profile.vue'),
    meta: {
      keepAlive: true,
    }
  }, {
    path: "/edit_profile",
    name: "router_edit_profile",
    component: () => import(/* webpackChunkName: "data" */ '@/components/user/EditProfile.vue'),
  }, {
    path: "/_tab_moment",
    name: "router_tab_moment",
    redirect: '/_tab_moment/moment',
    component: () => import(/* webpackChunkName: "data" */ '@/components/forum/MomentTabHeader.vue'),
    children: [{
      name: "moment_subtab",
      path: 'moment',
      component: () => import(/* webpackChunkName: "data" */ '@/components/forum/moment/MomentFeedPage.vue'),
      meta: {
        keepAlive: true,
      }
    }, {
      name: "notification_subtab",
      path: 'notification',
      component: () => import(/* webpackChunkName: "data" */ '@/components/notification/NotificationPage.vue'),
      meta: {
        keepAlive: true,
      }
    }]
  }, {
    path: "/feedback",
    name: "router_feedback",
    component: () => import(/* webpackChunkName: "data" */ '@/components/feedback/FeedbackPage.vue'),
  }, {
    path: "/notification",
    name: "router_notification",
    component: () => import(/* webpackChunkName: "data" */ '@/components/notification/NotificationPage.vue'),
  }, {
    path: "/message",
    name: "router_message",
    component: () => import(/* webpackChunkName: "data" */ '@/components/message/Message.vue'),
  }, {
    path: "/comment/:id",
    name: "comment_id",
    component: () => import(/* webpackChunkName: "data" */ '@/components/comment/CommentPage.vue'),
  }, {
    path: "/rate/item/:id",
    name: "rate_item_id",
    component: () => import(/* webpackChunkName: "data" */ '@/components/item_rate/ItemRatePage.vue'),
  }, {
    path: "/goods_remark/:id",
    name: 'router_goods_remark',
    component: () => import(/* webpackChunkName: "data" */ '@/components/shop/GoodsRemarkPage.vue'),
    meta: {
      keepAlive: true,
    }
  }, {
    path: '/goods_remark_create/:id',
    name: 'router_goods_remark_create_id',
    component: () => import(/* webpackChunkName: "data" */ '@/components/forum/moment/MomentCreateGoodsRemarkPage.vue'),
  }, {
    path: '/cart',
    name: 'router_cart',
    component: () => import(/* webpackChunkName: "data" */ '@/components/shop/Cart.vue')
  }, {
    path: '/good/:id',
    name: 'router_good_id',
    component: () => import(/* webpackChunkName: "data" */ '@/components/shop/GoodsDetail.vue'),
  }, {
    path: "/address",
    name: "router_address",
    component: () => import(/* webpackChunkName: "data" */ '@/components/shop/Address.vue'),
  }, {
    path: '/order_list',
    name: 'router_order_list',
    component: () => import(/* webpackChunkName: "data" */ '@/components/shop/OrderListPage.vue'),
  }, {
    path: '/ship_info',
    name: 'router_ship_info',
    component: () => import(/* webpackChunkName: "data" */ '@/components/shop/ShipInfo.vue'),
    meta: {
      keepAlive: true,
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: "/",
  routes: routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }
  },
})

export default router
